// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxSection_container__2VYwA","title":"BoxSection_title__2a_iS"};